export default __webpack_public_path__ + "static/media/1.34b61e5d.svg";